var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.824 7.928 19.904 12l-4.08 4.072v-1.995a.888.888 0 0 0-.89-.89h-4.45v-2.374h4.45c.493 0 .89-.397.89-.89V7.928zM21.758 12c0-.427-.17-.834-.47-1.135L16.98 6.57a1.72 1.72 0 0 0-2.937 1.217v1.246h-3.56a1.78 1.78 0 0 0-1.78 1.78v2.374c0 .983.797 1.78 1.78 1.78h3.56v1.246a1.722 1.722 0 0 0 2.937 1.217l4.306-4.295c.3-.3.471-.708.471-1.135zM9 5.473c.493 0 .89-.397.89-.89a.888.888 0 0 0-.89-.89H6.033a3.264 3.264 0 0 0-3.264 3.263v10.088a3.264 3.264 0 0 0 3.264 3.264H9c.493 0 .89-.397.89-.89a.888.888 0 0 0-.89-.89H6.033c-.82 0-1.484-.664-1.484-1.484V6.956c0-.82.664-1.483 1.484-1.483H9z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon-logout.a2003d37.svg";
export { ForwardRef as ReactComponent };